import { Box } from '@mui/system'
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import fiLocale from 'date-fns/locale/fi'

interface CustomTimePickerProps {
  value: Date | null
  onChange: (date: Date | null, fieldName: string) => void
  dateToCompare?: Date | null
  dateToCompareFieldName?: string
  isStartDate?: boolean
  label?: string
  name: string
  readOnly?: boolean
  isRequired?: boolean
  isError?: boolean
  disabled?: boolean
}

export default function CustomTimePicker({
  value,
  onChange,
  dateToCompare,
  dateToCompareFieldName = '',
  isStartDate = true,
  label,
  name,
  readOnly = false,
  isRequired = false,
  isError = false,
  disabled = false
}: Readonly<CustomTimePickerProps>) {
  const compareDates = (date: Date, dateToCompare: Date): void => {
    if (isStartDate && dateToCompare < date) {
      onChange(date, dateToCompareFieldName)
    }

    if (!isStartDate && dateToCompare > date) {
      onChange(date, dateToCompareFieldName)
    }
  }

  const handleChange = (date: Date | null) => {
    onChange(date, name)

    // only compare date values, if dateToCompare is provided in props
    if (dateToCompare && date !== null) {
      compareDates(date, dateToCompare)
    }
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fiLocale}>
        <TimePicker
          value={value}
          onChange={handleChange}
          label={label}
          readOnly={readOnly}
          ampm={false}
          timeSteps={{ minutes: 1 }}
          slotProps={{
            textField: {
              sx: {
                backgroundColor: 'background.default'
              },
              required: isRequired,
              error: isError,
              disabled: disabled
            }
          }}
        />
      </LocalizationProvider>
    </Box>
  )
}
